import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const ArrowRight: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className = '',
  ...props
}) => (
  <svg
    width={IconWidth[size]}
    height={IconHeight[size]}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={UNSAFE_className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.76518 6.18776C3.95502 5.99792 4.26281 5.99792 4.45265 6.18776L7.9978 9.73292L11.543 6.18776C11.7328 5.99792 12.0406 5.99792 12.2304 6.18776C12.4203 6.3776 12.4203 6.68539 12.2304 6.87523L8.34154 10.7641C8.25037 10.8553 8.12673 10.9065 7.9978 10.9065C7.86888 10.9065 7.74523 10.8553 7.65407 10.7641L3.76518 6.87523C3.57534 6.68539 3.57534 6.3776 3.76518 6.18776Z"
      fill={color}
    />
  </svg>
);

export default ArrowRight;
